import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://365luxuryhomes.com/api/admin/login",
        { username, password }
      );

      // Store the JWT token in localStorage (or cookies)
      localStorage.setItem("authToken", response.data.token);
      setToken(response.data.token);
      navigate("/");
      setError("");
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="w-full h-[100vh] flex items-center justify-center">
      <form onSubmit={handleSubmit} className="w-full max-w-md">
        <h2 className="text-2xl font-medium text-[#aca9a5]">Admin Login</h2>
        <div>
          <label className="label">Username</label>
          <input
            type="text"
            value={username}
            className="input input-bordered w-full max-w-md"
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="relative">
          <label className="label">Password</label>
          <input
            type={show ? "text" : "password"}
            value={password}
            className="input input-bordered w-full max-w-md"
            onChange={(e) => setPassword(e.target.value)}
          />
          {!show ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              onClick={() => setShow(!show)}
              className="text-inherit absolute right-2 bottom-[12px] cursor-pointer"
              fill={"none"}
            >
              <path
                d="M2 8C2 8 6.47715 3 12 3C17.5228 3 22 8 22 8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M21.544 13.045C21.848 13.4713 22 13.6845 22 14C22 14.3155 21.848 14.5287 21.544 14.955C20.1779 16.8706 16.6892 21 12 21C7.31078 21 3.8221 16.8706 2.45604 14.955C2.15201 14.5287 2 14.3155 2 14C2 13.6845 2.15201 13.4713 2.45604 13.045C3.8221 11.1294 7.31078 7 12 7C16.6892 7 20.1779 11.1294 21.544 13.045Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={24}
              height={24}
              onClick={() => setShow(!show)}
              className="text-inherit absolute right-2 bottom-[12px] cursor-pointer"
              fill={"none"}
            >
              <path
                d="M22 8C22 8 18 14 12 14C6 14 2 8 2 8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M15 13.5L16.5 16"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20 11L22 13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 13L4 11"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9 13.5L7.5 16"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <button
          type="submit"
          className="btn text-white w-full max-w-md mt-4 bg-[#aca9a5] hover:bg-[#6c675b]"
        >
          Login
        </button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default Login;
